module.exports = __webpack_public_path__ + "static/shoe-2-9d42310cd021eaa52e7331b5fe5c8991.png";